<template>
  <section class="mt-14 md:mt-14 w-full min-h-screen bg-subtleGray">
    <div class="relative pattern w-full">
      <div class="p-3 pb-0 md:p-6 md:pb-0 2xl:px-0 w-full max-w-1xl mx-auto">
        <div class="pt-6 flex items-start justify-between">
          <div class="mb-16 flex flex-col items-start justify-start">
            <h1 class="font-bold text-3xl text-white">
              {{
                $route.path.split("/").includes("downloads")
                  ? "downloads"
                  : $route.path.split("/").includes("collections") &&
                    $route.params.id
                  ? "Adobe collection"
                  : "Collections"
              }}
            </h1>
          </div>
        </div>
        <div class="w-full relative pb-3">
          <div
            class="w-full absolute -mb-5 bottom-0 flex items-start justify-between gap-5"
          >
            <div class="flex items-start justify-center gap-5">
              <router-link
                to="/downloads"
                :class="
                  $route.path.split('/').includes('downloads')
                    ? 'bg-brandPurple text-white'
                    : 'bg-subtleGray text-brandPurple'
                "
                class="px-5 py-2 border rounded-md border-brandPurple text-base font-medium"
              >
                <svg
                  class="md:hidden w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
                  />
                </svg>
                <span class="hidden md:block">Downloads</span>
              </router-link>
              <router-link
                to="/collections"
                :class="
                  $route.path.split('/').includes('collections')
                    ? 'bg-brandPurple text-white'
                    : 'bg-subtleGray text-brandPurple'
                "
                class="px-5 py-2 border rounded-md border-brandPurple text-base font-medium"
              >
                <svg
                  class="md:hidden w-5 h-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                  />
                </svg>
                <span class="hidden md:block">Collections</span>
              </router-link>
            </div>

            <div
              v-if="$route.params.id"
              class="flex items-start justify-center gap-5"
            >
              <button
                class="px-5 py-2 border border-gray-300 rounded-md text-sm bg-white text-blue-700 font-medium focus:outline-none flex items-center justify-center"
              >
                <svg
                  class="w-4 h-4 lg:mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                  />
                </svg>
                <span class="hidden lg:block">Edit collection</span>
              </button>
              <button
                class="px-5 py-2 border border-gray-300  rounded-md text-sm bg-white text-green-600  font-medium focus:outline-none flex items-center justify-center"
              >
                <svg
                  class="w-4 h-4 lg:mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z"
                  />
                </svg>
                <span class="hidden lg:block">Share collection</span>
              </button>
              <button
                class="px-5 py-2 border border-gray-300  rounded-md text-sm bg-white text-red-600 font-medium focus:outline-none flex items-center justify-center"
              >
                <svg
                  class="w-4 h-4 lg:mr-2"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="hidden lg:block">Delete collection</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="my-10 2xl:my-20 w-full p-3 pb-0 md:p-6 2xl:p-0 max-w-1xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-10"
    >
      <div
        @mouseenter="addCollectionHovered = true"
        @mouseleave="addCollectionHovered = false"
        class="relative w-full h-collectionCardHeight border border-gray-300 rounded-md p-5 bg-white"
      >
        <div
          @click="changeState('modal')"
          v-if="state === 'default'"
          :class="{ blur: addCollectionHovered }"
          class="absolute cursor-pointer inset-0 z-20 overlay rounded-md flex items-center justify-center"
        >
          <svg
            class="w-14 h-14 text-gray-700"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
              clip-rule="evenodd"
            />
          </svg>
        </div>

        <div v-if="state === 'default'" class="w-full">
          <div class="flex items-center justify-between">
            <h1 class="text-sm font-medium text-gray-800">
              Create a new Collection
            </h1>
            <button
              class="rounded-full p-2 hover:bg-gray-200 focus:outline-none"
            >
              <svg
                class="w-5 h-5 text-gray-700"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg>
            </button>
          </div>

          <!-- grid -->
          <div class="mt-12 pt-1 my-5 grid grid-cols-2 gap-5">
            <div class="bg-gray-400 rounded-md w-full image-container ">
              <div class="absolute inset-0 flex items-center justify-center">
                <svg
                  class=" w-10 h-10 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div class="bg-gray-400 rounded-md w-full image-container ">
              <div class="absolute inset-0 flex items-center justify-center">
                <svg
                  class=" w-10 h-10 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div class="bg-gray-400 rounded-md w-full image-container ">
              <div class="absolute inset-0 flex items-center justify-center">
                <svg
                  class=" w-10 h-10 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <div class="bg-gray-400 rounded-md w-full image-container ">
              <div class="absolute inset-0 flex items-center justify-center">
                <svg
                  class=" w-10 h-10 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
          <!-- end of grid -->

          <button
            class="py-2 px-3 text-center text-sm text-gray-600 bg-gray-200 hover:bg-gray-300 rounded-md block w-full focus:outline-none"
          >
            View Collection
          </button>
        </div>

        <div
          v-else
          class="w-full h-full flex items-center flex-col justify-center"
        >
          <input
            v-model="collectionName"
            placeholder="Collection Name"
            class="w-full rounded-md border text-sm placeholder-gray-500 border-gray-300 focus:outline-none px-3 py-2"
            type="text"
          />

          <div class="w-full flex items-center justify-between space-x-4">
            <button
              @click="changeState('default')"
              class="mt-6 px-4 py-2 rounded-md text-sm text-gray-500 border border-gray-300 text-center hover:bg-gray-200 focus:outline-none"
            >
              Cancel
            </button>
            <button
              @click="handleCreate"
              class="mt-6 w-full px-3 py-2 rounded-md text-sm text-white font-medium text-center bg-buttonColor focus:outline-none"
            >
              Create Collection
            </button>
          </div>
        </div>
      </div>

      <CollectionCard
        v-for="collection in getAvailableCollections"
        :key="collection.id"
        :id="collection.id"
        :title="collection.name"
        :products="collection.products"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CollectionCard from "../components/utils/CollectionCard.vue";
export default {
  name: "collections",
  components: { CollectionCard },
  mounted() {
    if (this.getCurrentUser) {
      this.fetchAvailableCollections();
    }
  },
  computed: {
    ...mapGetters(["getAvailableCollections"]),
    ...mapGetters(["getLoading"]),
    ...mapGetters(["getCurrentUser"]),
  },
  methods: {
    ...mapActions(["createCollection"]),
    ...mapActions(["fetchAvailableCollections"]),

    handleCreate() {
      this.createCollection({ name: this.collectionName });
      this.collectionName = "";
      this.state = "default";
    },

    changeState(state) {
      this.state = state;
    },
  },
  data() {
    return {
      addCollectionHovered: false,
      state: "default",
      collectionName: "",
    };
  },
};
</script>
<style scoped>
.overlay {
  background: rgba(207, 207, 207, 0.287);
}

.blur {
  backdrop-filter: blur(2px);
}

.image-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
}
.pattern {
  background-color: #181818;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25'%3E%3Cdefs%3E%3ClinearGradient id='a' gradientUnits='userSpaceOnUse' x1='0' x2='0' y1='0' y2='100%25' gradientTransform='rotate(0,842,429)'%3E%3Cstop offset='0' stop-color='%23181818'/%3E%3Cstop offset='1' stop-color='%23404040'/%3E%3C/linearGradient%3E%3Cpattern patternUnits='userSpaceOnUse' id='b' width='436' height='363.3' x='0' y='0' viewBox='0 0 1080 900'%3E%3Cg fill-opacity='0.1'%3E%3Cpolygon fill='%23444' points='90 150 0 300 180 300'/%3E%3Cpolygon points='90 150 180 0 0 0'/%3E%3Cpolygon fill='%23AAA' points='270 150 360 0 180 0'/%3E%3Cpolygon fill='%23DDD' points='450 150 360 300 540 300'/%3E%3Cpolygon fill='%23999' points='450 150 540 0 360 0'/%3E%3Cpolygon points='630 150 540 300 720 300'/%3E%3Cpolygon fill='%23DDD' points='630 150 720 0 540 0'/%3E%3Cpolygon fill='%23444' points='810 150 720 300 900 300'/%3E%3Cpolygon fill='%23FFF' points='810 150 900 0 720 0'/%3E%3Cpolygon fill='%23DDD' points='990 150 900 300 1080 300'/%3E%3Cpolygon fill='%23444' points='990 150 1080 0 900 0'/%3E%3Cpolygon fill='%23DDD' points='90 450 0 600 180 600'/%3E%3Cpolygon points='90 450 180 300 0 300'/%3E%3Cpolygon fill='%23666' points='270 450 180 600 360 600'/%3E%3Cpolygon fill='%23AAA' points='270 450 360 300 180 300'/%3E%3Cpolygon fill='%23DDD' points='450 450 360 600 540 600'/%3E%3Cpolygon fill='%23999' points='450 450 540 300 360 300'/%3E%3Cpolygon fill='%23999' points='630 450 540 600 720 600'/%3E%3Cpolygon fill='%23FFF' points='630 450 720 300 540 300'/%3E%3Cpolygon points='810 450 720 600 900 600'/%3E%3Cpolygon fill='%23DDD' points='810 450 900 300 720 300'/%3E%3Cpolygon fill='%23AAA' points='990 450 900 600 1080 600'/%3E%3Cpolygon fill='%23444' points='990 450 1080 300 900 300'/%3E%3Cpolygon fill='%23222' points='90 750 0 900 180 900'/%3E%3Cpolygon points='270 750 180 900 360 900'/%3E%3Cpolygon fill='%23DDD' points='270 750 360 600 180 600'/%3E%3Cpolygon points='450 750 540 600 360 600'/%3E%3Cpolygon points='630 750 540 900 720 900'/%3E%3Cpolygon fill='%23444' points='630 750 720 600 540 600'/%3E%3Cpolygon fill='%23AAA' points='810 750 720 900 900 900'/%3E%3Cpolygon fill='%23666' points='810 750 900 600 720 600'/%3E%3Cpolygon fill='%23999' points='990 750 900 900 1080 900'/%3E%3Cpolygon fill='%23999' points='180 0 90 150 270 150'/%3E%3Cpolygon fill='%23444' points='360 0 270 150 450 150'/%3E%3Cpolygon fill='%23FFF' points='540 0 450 150 630 150'/%3E%3Cpolygon points='900 0 810 150 990 150'/%3E%3Cpolygon fill='%23222' points='0 300 -90 450 90 450'/%3E%3Cpolygon fill='%23FFF' points='0 300 90 150 -90 150'/%3E%3Cpolygon fill='%23FFF' points='180 300 90 450 270 450'/%3E%3Cpolygon fill='%23666' points='180 300 270 150 90 150'/%3E%3Cpolygon fill='%23222' points='360 300 270 450 450 450'/%3E%3Cpolygon fill='%23FFF' points='360 300 450 150 270 150'/%3E%3Cpolygon fill='%23444' points='540 300 450 450 630 450'/%3E%3Cpolygon fill='%23222' points='540 300 630 150 450 150'/%3E%3Cpolygon fill='%23AAA' points='720 300 630 450 810 450'/%3E%3Cpolygon fill='%23666' points='720 300 810 150 630 150'/%3E%3Cpolygon fill='%23FFF' points='900 300 810 450 990 450'/%3E%3Cpolygon fill='%23999' points='900 300 990 150 810 150'/%3E%3Cpolygon points='0 600 -90 750 90 750'/%3E%3Cpolygon fill='%23666' points='0 600 90 450 -90 450'/%3E%3Cpolygon fill='%23AAA' points='180 600 90 750 270 750'/%3E%3Cpolygon fill='%23444' points='180 600 270 450 90 450'/%3E%3Cpolygon fill='%23444' points='360 600 270 750 450 750'/%3E%3Cpolygon fill='%23999' points='360 600 450 450 270 450'/%3E%3Cpolygon fill='%23666' points='540 600 630 450 450 450'/%3E%3Cpolygon fill='%23222' points='720 600 630 750 810 750'/%3E%3Cpolygon fill='%23FFF' points='900 600 810 750 990 750'/%3E%3Cpolygon fill='%23222' points='900 600 990 450 810 450'/%3E%3Cpolygon fill='%23DDD' points='0 900 90 750 -90 750'/%3E%3Cpolygon fill='%23444' points='180 900 270 750 90 750'/%3E%3Cpolygon fill='%23FFF' points='360 900 450 750 270 750'/%3E%3Cpolygon fill='%23AAA' points='540 900 630 750 450 750'/%3E%3Cpolygon fill='%23FFF' points='720 900 810 750 630 750'/%3E%3Cpolygon fill='%23222' points='900 900 990 750 810 750'/%3E%3Cpolygon fill='%23222' points='1080 300 990 450 1170 450'/%3E%3Cpolygon fill='%23FFF' points='1080 300 1170 150 990 150'/%3E%3Cpolygon points='1080 600 990 750 1170 750'/%3E%3Cpolygon fill='%23666' points='1080 600 1170 450 990 450'/%3E%3Cpolygon fill='%23DDD' points='1080 900 1170 750 990 750'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect x='0' y='0' fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect x='0' y='0' fill='url(%23b)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}
</style>
